import { ChangeEvent } from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { FormControlModel } from "types";
import ErrorMessage from "ui/atoms/ErrorMessage";
import { useField } from "formik";
import get from "lodash/get";

const CheckboxGroupForm = ({
  name,
  label,
  formik,
  questionData,
  checkboxStyle,
  visible = true,
  isRanking = false,
}: FormControlModel) => {
  const [field, meta] = useField(name);

  const getRanking = (values: any[]): number => {
    if (isRanking) {
      if (values?.length > 0) {
        return values[values?.length - 1]?.subSectionId + 1;
      }
      return 1;
    }
    return 0;
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked, name, value } = event.target;

    if (checked) {
      formik.setFieldValue(name, [
        ...formik.values[name],
        {
          questionID: questionData?.id,
          value,
          subSectionId: getRanking(formik.values[name]),
        },
      ]);
    } else {
      formik.setFieldValue(
        name,
        formik.values[name].filter((v: any) => {
          return v.value !== value;
        })
      );
    }
  };
  if (!questionData) return <></>;
  return visible ? (
    <Box sx={{ display: "flex" }}>
      <FormControl
        sx={{ mt: 2 }}
        name={name}
        variant='standard'
        component='fieldset'
        error={meta.touched && Boolean(meta.error)}
      >
        <FormLabel component='legend'>{label}</FormLabel>
        <FormGroup row>
          {questionData?.source?.map((item: any) => {
            return (
              <FormControlLabel
                key={item?.value}
                sx={checkboxStyle}
                control={
                  <Checkbox
                    name={name}
                    value={item.value}
                    onChange={handleChange}
                    checked={formik.values[name]?.some((obj: any) => obj.value === item.value)}
                  />
                }
                label={item?.descripcion}
              />
            );
          })}
        </FormGroup>
        <ErrorMessage>{formik?.errors[name]}</ErrorMessage>
      </FormControl>
    </Box>
  ) : null;
};

export default CheckboxGroupForm;
